import ContactForm from "../sections/ContactForm";
import Icon from "../components/Icon";

export default function Contact() {
  return (
    <>
      <div className="bg-contacts lg:bg-hero-home-dark w-full h-[70vh] bg-cover bg-center flex items-center justify-center">
        <div className="bg-black bg-opacity-25 w-full h-[70vh] absolute top-0 left-0"></div>
        <h1 className="text-5xl text-white font-extrabold z-20">Контакти</h1>
      </div>
      <div className="w-[90%] lg:w-2/3 mx-auto mt-32 flex flex-col items-center justify-center">
        <div className="flex items-center gap-1">
          <div className="bg-brand w-16 rounded-full h-[6px]"></div>
          <div className="bg-brand w-8 rounded-full h-[6px]"></div>
          <div className="bg-brand w-2 rounded-full h-[6px]"></div>
        </div>
        <h2 className="text-3xl font-extrabold text-heading">
          Свържете се с нас:
        </h2>
        <div className="flex flex-col my-8 lg:flex-row w-full items-center justify-between gap-4">
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="email" className="w-10 h-10" />
            <a
              href="mailto:tomov.dentalclinic@gmail.com"
              target="_blank"
              rel="noreferrer"
              className="text-heading hover:underline font-bold text-lg"
            >
              tomov.dentalclinic
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="phone" className="w-10 h-10" />
            <a
              href="tel:088 528 5757"
              target="_blank"
              rel="noreferrer"
              className="text-heading hover:underline font-bold text-lg"
            >
              088 528 5757
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="location" className="w-10 h-10" />
            <a
              href="https://maps.app.goo.gl/GWjbmeVQZosEFJNv9"
              target="_blank"
              rel="noreferrer"
              className="text-heading hover:underline font-bold text-lg"
            >
              ul.Opalchenska 94
            </a>
          </div>
        </div>
        <ContactForm />
      </div>
    </>
  );
}
